import { render, staticRenderFns } from "./Banzufenbao.vue?vue&type=template&id=4cce5688&scoped=true"
import script from "./Banzufenbao.vue?vue&type=script&lang=js"
export * from "./Banzufenbao.vue?vue&type=script&lang=js"
import style0 from "./Banzufenbao.vue?vue&type=style&index=0&id=4cce5688&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cce5688",
  null
  
)

export default component.exports